const POPUP_ENABLED = true;
const SALES_API_URL = "https://cp-recent-sales.alainbenitah-26f.workers.dev/sales";

// Nombre de jours à retenir pour les ventes réelles
const RECENT_DAYS = 4;

let fixedSalesData = [];
let realSalesData = [];
let salesData = [];

const popupShownCount = {};

const popup = document.getElementById("cp-sales-popup");
const popupImg = document.getElementById("cp-sales-img");
const popupTitle = document.getElementById("cp-sales-title");
const popupPrice = document.getElementById("cp-sales-price");
const popupName = document.getElementById("cp-sales-name");
const popupCity = document.getElementById("cp-sales-city");
const popupClose = document.getElementById("cp-sales-close");
const popupFree = document.getElementById("cp-sales-free");
const popupPrefix = document.getElementById("cp-sales-prefix");
const popupAction = document.getElementById("cp-sales-action");

let justShownPriorityKey = "";
let popupIndex = 0;
let hideTimer = null;
let currentUrl = "";
let latestRealSaleKeySeen = "";
let pendingPrioritySale = null;

// ================== UTILITAIRES ==================
function formatMoney(cents) {
  return (cents / 100).toFixed(2).replace(".", ",") + " €";
}

function normalizeCity(city) {
  const value = String(city || "").trim();
  if (!value) return "";
  return /^de\s/i.test(value) ? value : "de " + value;
}

function normalizePrice(value) {
  let s = String(value || "").trim();
  if (!s) return "";
  if (s.includes("€")) return s.replace(".", ",");
  if (/^\d+(\.\d+)?$/.test(s)) return s.replace(".", ",") + " €";
  return s.replace(".", ",");
}

function getPopupPurchaseData(item) {
  const discount = Number(item.discount_percent || 0);
  const price = String(item.price || "").replace(",", ".");

  // CAS GRATUIT
  if (price === "0.00" || price === "0") {
    return {
      action: "vient de l’obtenir",
      prefix: "",
      value: "gratuitement"
    };
  }

  // CAS PROMO %
  if (discount >= 15) {
    return {
      action: "vient de l’acheter",
      prefix: "à",
      value: "-" + discount + "%"
    };
  }

  // CAS NORMAL
  return {
    action: "vient de l’acheter",
    prefix: "pour",
    value: normalizePrice(item.price)
  };
}

function shuffleArray(arr) {
  return [...arr].sort(() => Math.random() - 0.5);
}

// ================== FILTRAGE DES VENTES RÉCENTES ==================
function filterRecentSales(sales, days = RECENT_DAYS) {
  const now = new Date();
  const cutoff = new Date(now.getTime() - days * 24 * 60 * 60 * 1000);
  return sales.filter(item => {
    const created = new Date(item.created_at);
    return created >= cutoff;
  });
}

// ================== FIXES ==================
async function loadFixedSales() {
  if (!Array.isArray(window.cpSalesData)) {
    fixedSalesData = [];
    return;
  }

  const promises = window.cpSalesData.map(async (item) => {
    try {
      if (!item || !item.handle) return null;
      const r = await fetch(`/products/${item.handle}.js`, { cache: "no-store" });
      if (!r.ok) return null;
      const p = await r.json();
      const variantId = String(item.variant_id || "").trim();

const selectedVariant =
  variantId && Array.isArray(p.variants)
    ? p.variants.find((variant) => String(variant.id) === variantId)
    : null;

const imgUrl =
  selectedVariant?.featured_image?.src ||
  p.featured_image ||
  "";

if (!imgUrl) return null;

const displayedPrice = selectedVariant?.price ?? p.price ?? 0;

const productUrl =
  "/products/" +
  item.handle +
  (variantId ? "?variant=" + encodeURIComponent(variantId) : "");

const preload = new Image();
preload.src = imgUrl;

return {
  source: "fixed",
  key: `fixed||${item.handle}||${variantId}||${item.name || ""}||${item.city || ""}`,
  title: p.title || "",
  price: formatMoney(displayedPrice),
  purchase_data: {
    action: "vient de l’acheter",
    prefix: "pour",
    value: formatMoney(displayedPrice)
  },
  url: productUrl,
  img: imgUrl,
  name: item.name || "Client",
  city: normalizeCity(item.city || ""),
  free_shipping: Boolean(item.free_shipping)
};


    } catch (e) {
      return null;
    }
  });

  const results = await Promise.all(promises);
  fixedSalesData = results.filter(Boolean);
}

// ================== VENTES RÉELLES ==================
async function loadRealSales() {
  try {
    const r = await fetch(SALES_API_URL, { cache: "no-store" });
    if (!r.ok) {
      realSalesData = [];
      return;
    }

    const data = await r.json();
    if (!Array.isArray(data)) {
      realSalesData = [];
      return;
    }

    realSalesData = filterRecentSales(data, RECENT_DAYS)
      .filter(item => item && item.title && item.url && item.img)
      .map((item, index) => {
        const preload = new Image();
        preload.src = item.img;

        let name = item.name || "Client";
        let city = normalizeCity(item.city || "");

        const testName = String(name).trim().toUpperCase();
        const testCity = String(city).trim().toUpperCase().replace(/^DE\s+/, "");

        // Exclure cette vente des popups
if (testName === "ALAIN" && testCity.includes("PONTAULT")) {
  return null;
}

        return {
          source: "real",
          key: `real||${item.variant_id || ""}||${item.product_id || ""}||${item.created_at || index}`,
          title: item.title || "",
          price: item.price || "",
          purchase_data: getPopupPurchaseData(item),
          discount_percent: Number(item.discount_percent || 0),
          free_shipping: Boolean(item.free_shipping),
          url: item.url || "",
          img: item.img || "",
          name: name,
          city: city,
          created_at: item.created_at
         };
      })
            .filter(Boolean);

    const newest = realSalesData[0];

    if (newest && newest.key !== latestRealSaleKeySeen) {
      latestRealSaleKeySeen = newest.key;
      pendingPrioritySale = newest;
    }

  } catch (e) {
    console.error("Erreur chargement ventes réelles :", e);
    realSalesData = [];
  }
}

// ================== RECONSTRUCTION DES POPUP ==================
function rebuildSalesData() {
  const fixed = shuffleArray(fixedSalesData);
  const real = [...realSalesData];

  const mixed = [];
  const maxLen = Math.max(real.length, fixed.length);

  for (let i = 0; i < maxLen; i++) {
    if (real[i]) mixed.push(real[i]);
    if (fixed[i]) mixed.push(fixed[i]);
  }

  salesData = mixed;

  if (popupIndex >= salesData.length) popupIndex = 0;
}

async function refreshSalesData() {
  await loadRealSales();
  rebuildSalesData();
}

// ================== AFFICHAGE ==================
function hideFixedPopup() {
  if (!popup) return;
  popup.classList.remove("show");
  popup.classList.remove("has-free-shipping");
  popup.setAttribute("aria-hidden", "true");
  clearTimeout(hideTimer);
}

function canShowFixedPopup() {
  return true;
}

function scheduleNextPopup() {
  const delay = 24000 + Math.random() * 12000;
  setTimeout(async () => {
    await refreshSalesData();
    showPopup();
    scheduleNextPopup();
  }, delay);
}

function getNextEligibleItem() {
  if (!salesData.length && !pendingPrioritySale) return null;

  if (pendingPrioritySale) {
  const priority = pendingPrioritySale;
  pendingPrioritySale = null;
  justShownPriorityKey = priority.key || "";
  return priority;
}

  if (!salesData.length) return null;

  let checked = 0;
  while (checked < salesData.length) {
    const item = salesData[popupIndex];
    popupIndex++;

    if (popupIndex >= salesData.length) {
      popupIndex = 0;
      salesData = shuffleArray(salesData);
    }

    checked++;

    if (!item || !item.img || !item.url) continue;

    if (item.source === "fixed") {
      const shown = popupShownCount[item.key] || 0;
      if (shown >= 2) continue;
    }
    
    if (justShownPriorityKey && item.key === justShownPriorityKey) {
  justShownPriorityKey = "";
  continue;
    }


    return item;
  }

  return null;
}

function showPopup() {
  if (!POPUP_ENABLED || !popup || !canShowFixedPopup()) return;

  const item = getNextEligibleItem();
  if (!item) return;

  if (item.source === "fixed") {
    popupShownCount[item.key] = (popupShownCount[item.key] || 0) + 1;
  }

  currentUrl = item.url || "";
  popupTitle.textContent = item.title || "";
  const purchaseData = item.purchase_data || {
  action: "vient de l’acheter",
  prefix: "pour",
  value: item.price || ""
};

if (popupAction) {
  popupAction.textContent = purchaseData.action || "vient de l’acheter";
}

if (popupPrefix) {
  popupPrefix.textContent = purchaseData.prefix || "";
}

popupPrice.textContent = purchaseData.value || "";
  popupName.textContent = item.name || "Client";
  popupCity.textContent = item.city || "";

  if (popupFree) {
    popupFree.textContent = item.free_shipping ? "– Livraison gratuite –" : "";
  }

  popupImg.src = item.img || "";
  popupImg.alt = item.title || "";

  if (item.free_shipping) {
    popup.classList.add("has-free-shipping");
  } else {
    popup.classList.remove("has-free-shipping");
  }

  popup.classList.add("show");
  popup.setAttribute("aria-hidden", "false");

  clearTimeout(hideTimer);
  hideTimer = setTimeout(hideFixedPopup, 7000);
}

if (popupClose) {
  popupClose.addEventListener("click", (e) => {
    e.stopPropagation();
    hideFixedPopup();
  });
}

if (popup) {
  popup.addEventListener("click", () => {
    if (currentUrl) window.open(currentUrl, "_blank");
  });

  popup.addEventListener("mouseenter", () => clearTimeout(hideTimer));

  popup.addEventListener("mouseleave", () => {
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hideFixedPopup, 4000);
  });
}

// ================== INIT ==================
if (POPUP_ENABLED) {
  window.addEventListener("load", async () => {
    await loadFixedSales();
    await refreshSalesData();

    setTimeout(() => {
      showPopup();
      scheduleNextPopup();
    }, 12000);
  });
}